module.exports = __webpack_public_path__ + "static/Integris-69b7a6a00d65f867d9774d144a5e00b7.jpg";